import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, radius, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const style = {
  card: { ...s.card, padding: '24px' },
  input: s.input,
  label: s.labelNormal,
  select: s.select,
}

function extractYtId(s) {
  s = (s || '').trim()
  const m = s.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([A-Za-z0-9_-]{11})/)
  if (m) return m[1]
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s
  return ''
}

const DEFAULT_CONFIG = { is_active: false, title: 'Videolu Anlatım', anchor_selector: '', position: 'before', home_only: true }

export default function SmartVideo() {
  const { selectedBrand } = useBrand()
  const navigate = useNavigate()
  const [config, setConfig] = useState(DEFAULT_CONFIG)
  const [videos, setVideos] = useState([])
  const [newUrl, setNewUrl] = useState('')
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  useEffect(() => {
    if (!selectedBrand) return
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-video-config`, { headers })
      .then(res => { if (res.data && res.data.brand_id) setConfig({ ...DEFAULT_CONFIG, ...res.data }) })
      .catch(() => {})
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-videos`, { headers })
      .then(res => setVideos((res.data || []).map(v => ({ ...v, _prod: null }))))
      .catch(() => {})
  }, [selectedBrand?.id]) // eslint-disable-line

  function set(key, value) { setConfig(c => ({ ...c, [key]: value })) }
  function setVid(i, key, value) { setVideos(vs => vs.map((v, idx) => idx === i ? { ...v, [key]: value } : v)) }

  function addVideo() {
    const id = extractYtId(newUrl)
    if (!id) { alert('Geçerli bir YouTube linki gir'); return }
    setVideos(vs => [...vs, { youtube_id: id, product_code: '', is_active: true, _prod: null }])
    setNewUrl('')
  }
  function removeVideo(i) { setVideos(vs => vs.filter((_, idx) => idx !== i)) }
  function move(i, d) {
    setVideos(vs => {
      const a = [...vs]; const j = i + d
      if (j < 0 || j >= a.length) return a
      const t = a[i]; a[i] = a[j]; a[j] = t; return a
    })
  }
  function lookupProduct(i) {
    const code = (videos[i].product_code || '').trim()
    if (!code) return
    axios.get(`${API}/admin/brands/${selectedBrand.id}/product-lookup?code=${encodeURIComponent(code)}`, { headers })
      .then(res => setVid(i, '_prod', res.data || { _notfound: true }))
      .catch(() => setVid(i, '_prod', { _notfound: true }))
  }

  async function handleSave() {
    setSaving(true)
    await axios.put(`${API}/admin/brands/${selectedBrand.id}/smart-video-config`, config, { headers })
    await axios.put(`${API}/admin/brands/${selectedBrand.id}/smart-videos`, { videos: videos.map(v => ({ youtube_id: v.youtube_id, product_code: v.product_code, is_active: v.is_active })) }, { headers })
    setSaving(false); setSaved(true); setTimeout(() => setSaved(false), 2500)
  }

  if (!selectedBrand) return (
    <div style={{ textAlign: 'center', padding: '60px' }}>
      <p style={{ ...ui.notice, display: 'inline-block', marginBottom: '16px' }}>Önce bir marka seçin.</p>
      <button onClick={() => navigate('/brands')} style={s.btnPrimary}>Markalara Git</button>
    </div>
  )

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <div className="sx-break" style={{ minWidth: 0 }}>
          <h2 style={s.pageTitle}>Smart Video — {selectedBrand.name}</h2>
          <p style={s.pageSubtitle}>Anasayfada hover-autoplay video + ürün pin (YouTube API'siz)</p>
        </div>
        <div className="sx-wrap" style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={ui.status(config.is_active)}><span style={ui.statusDot(config.is_active)} />{config.is_active ? 'Aktif' : 'Pasif'}</span>
          <button onClick={handleSave} disabled={saving} style={{ ...s.btnPrimary, opacity: saving ? 0.6 : 1 }}>
            {saving ? 'Kaydediliyor...' : saved ? '✓ Kaydedildi' : 'Kaydet'}
          </button>
        </div>
      </div>

      <div style={style.card}>
        <div style={{ marginBottom: '18px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
            <input type="checkbox" checked={config.is_active} onChange={e => set('is_active', e.target.checked)} /> Smart Video aktif
          </label>
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={style.label}>Blok başlığı</label>
          <input style={style.input} value={config.title || ''} onChange={e => set('title', e.target.value)} placeholder="Videolu Anlatım" />
        </div>
      </div>

      <div style={style.card}>
        <label style={style.label}>Videolar ({videos.length})</label>
        <div className="sx-wrap" style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <input style={{ ...style.input, flex: '1 1 220px', maxWidth: '100%' }} value={newUrl} onChange={e => setNewUrl(e.target.value)} placeholder="YouTube linki yapıştır (Shorts / watch / youtu.be)" onKeyDown={e => e.key === 'Enter' && addVideo()} />
          <button onClick={addVideo} style={{ ...s.btnSecondary, whiteSpace: 'nowrap' }}>Ekle</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {videos.map((v, i) => (
            <div key={i} className="sx-wrap" style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap', border: `1px solid ${colors.border}`, borderRadius: radius.md, padding: '10px', background: colors.bgCard }}>
              <img src={`https://i.ytimg.com/vi/${v.youtube_id}/mqdefault.jpg`} alt="" style={{ width: '54px', height: '72px', objectFit: 'cover', borderRadius: radius.sm, flexShrink: 0 }} />
              <div style={{ flex: '1 1 200px', minWidth: 0 }}>
                <div style={{ fontSize: '12px', color: colors.textMuted, marginBottom: '6px' }}>Video ID: {v.youtube_id}</div>
                <div className="sx-wrap" style={{ display: 'flex', gap: '6px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <input style={{ ...style.input, padding: '7px 10px', fontSize: '13px', flex: '1 1 160px', maxWidth: '100%' }} value={v.product_code || ''} onChange={e => setVid(i, 'product_code', e.target.value)} placeholder="Ürün kodu (product_code)" />
                  <button onClick={() => lookupProduct(i)} style={{ ...ui.btnSm, whiteSpace: 'nowrap', padding: '7px 12px' }}>Getir</button>
                </div>
                {v._prod && (v._prod._notfound
                  ? <div style={{ fontSize: '12px', color: colors.dangerText, marginTop: '5px' }}>Ürün bulunamadı</div>
                  : <div className="sx-break" style={{ ...ui.numMuted, fontSize: '12px', marginTop: '5px' }}>✓ {v._prod.name} — {parseFloat(v._prod.price).toLocaleString('tr-TR')} TL</div>
                )}
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', cursor: 'pointer' }}>
                <input type="checkbox" checked={v.is_active !== false} onChange={e => setVid(i, 'is_active', e.target.checked)} /> Aktif
              </label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <button onClick={() => move(i, -1)} style={{ ...ui.btnSm, padding: '2px 8px' }}>↑</button>
                <button onClick={() => move(i, 1)} style={{ ...ui.btnSm, padding: '2px 8px' }}>↓</button>
              </div>
              <button onClick={() => removeVideo(i)} style={{ ...ui.btnDangerQuiet, padding: '6px 10px' }}>Sil</button>
            </div>
          ))}
          {!videos.length && <div style={{ ...ui.emptyText, textAlign: 'center', padding: '24px' }}>Henüz video eklenmedi</div>}
        </div>
      </div>
    </div>
  )
}
